__turbopack_context__.v({
  "marqueeContainer": "ImageMarqueeSection-module__ABOYGG__marqueeContainer",
  "section": "ImageMarqueeSection-module__ABOYGG__section",
  "slide": "ImageMarqueeSection-module__ABOYGG__slide",
  "slideImage": "ImageMarqueeSection-module__ABOYGG__slideImage",
  "track": "ImageMarqueeSection-module__ABOYGG__track",
});
